import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'equals'
})
export class Equals implements PipeTransform {

  transform(value: any, comparedValue: any): boolean {
    return (typeof value !== 'undefined' && value !== null && value !== '') && value === comparedValue;
  }

}
